import { setInstanceValues } from './instance-values-actions';
import type { ParsedInstance } from './parse-instance';

type State = ParsedInstance;

type AnyAction = ReturnType<typeof setInstanceValues>;

export function instanceValues(state: State = {} as State, action: AnyAction): State {
  switch (action.type) {
    case setInstanceValues.type:
      return action.payload;
    default:
      return state;
  }
}
